import { Component, EventEmitter, Input, Output } from '@angular/core';
import { PlayAudio, Resume, Stop } from '@app/core/states/audio.actions';
import { ArchivedTrack } from '@app/library/models/trash.model';
import { ToggleSelectArchivedTrack } from '@app/library/states/selected-tracks.actions';
import { SelectedTracksState } from '@app/library/states/selected-tracks.state';
import { Dispatch } from '@ngxs-labs/dispatch-decorator';
import { Select, Store } from '@ngxs/store';
import { ContextMenuComponent, ContextMenuService } from '@perfectmemory/ngx-contextmenu';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { ColumnShown } from '../../../models/column-shown.model';

@Component({
  selector: 'rk-trash-audio-line',
  templateUrl: './trash-audio-line.component.html',
  styleUrls: ['./trash-audio-line.component.scss'],
})
export class TrashAudioLineComponent {
  @Input()
  set isContextMenuOpen(isOpen: boolean) {
    if (this.hasContextMenuOpen && !isOpen) {
      this.hasContextMenuOpen = false;
    }
  }

  @Input()
  set archivedTrack(inArchivedTrack: ArchivedTrack) {
    this._archivedTrack = inArchivedTrack;
    this.checked$ = this.store
      .select(SelectedTracksState.isArchivedTrackSelected)
      .pipe(map(fn => fn(inArchivedTrack)));
  }

  get archivedTrack(): ArchivedTrack {
    return this._archivedTrack;
  }

  _archivedTrack: ArchivedTrack;

  @Input()
  isPlaying = false;

  @Input()
  isLoaded = false;

  @Input()
  hasPaddingRight = false;

  @Input()
  columns: ColumnShown;

  @Select(SelectedTracksState.numberArchivedTracksSelected)
  numberCheckedArchivedTracks$: Observable<number>;

  @Output()
  readonly shiftClicked = new EventEmitter<number>();

  checked$: Observable<boolean>;

  // Optional
  @Input() contextMenu: ContextMenuComponent;

  hasContextMenuOpen = false;

  constructor(
    private readonly contextMenuService: ContextMenuService,
    private readonly store: Store,
  ) {}

  selectLine() {
    this.store.dispatch(new ToggleSelectArchivedTrack(this.archivedTrack, true));
  }

  onSelectClickLine(event: MouseEvent) {
    const isMacOS = !!navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i);
    if (event.ctrlKey || (isMacOS && event.metaKey)) {
      this.store.dispatch(new ToggleSelectArchivedTrack(this.archivedTrack));

      return;
    }
    if (event.shiftKey) {
      this.shiftClicked.emit(this.archivedTrack.id);
      event.stopPropagation();
      event.preventDefault();
    }
  }

  @Dispatch()
  playArchivedTrack(archivedTrack: ArchivedTrack) {
    if (this.isPlaying && this.isLoaded) {
      return new Stop();
    }
    if (this.isLoaded) {
      return new Resume();
    }

    return new PlayAudio(archivedTrack);
  }

  onContextMenu($event: MouseEvent, item: any): void {
    this.hasContextMenuOpen = true;
    this.contextMenuService.show.next({
      item,
      contextMenu: this.contextMenu,
      event: $event,
    });
    $event.preventDefault();
    $event.stopPropagation();
  }
}
